module.exports = __webpack_public_path__ + "img/jiaju4_active.2b9eed83.png";